import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { generalStore } from '@/store';
import Select2 from 'vue3-select2-component';
// import infiniteScroll from 'vue-infinite-scroll';
import { api } from '@/services/Api';
import ApModalBase from './components/Modals/ApModalBase.vue';
import BtnWithIcon from '@/components/BtnWithIcon.vue';
import FileUpload from '@/components/FileUpload.vue';
import HelpersPlugin from '@/components/Helpers';
import mixin from '@/mixin';
import { VueClipboard } from '@soerenmartius/vue3-clipboard';
import Toaster from '@meforma/vue-toaster';
import { vfmPlugin } from 'vue-final-modal';
import { useAccordion } from 'vue3-rich-accordion';
import i18n, { tbase } from '@/i18n';
import { loadLanguageAsync } from '@/i18n-initializer';
import KProgress from 'k-progress-v3';

import Datepicker from '@vuepic/vue-datepicker';

import '@vuepic/vue-datepicker/dist/main.css';
import 'vue3-rich-accordion/accordion-library-styles.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './assets/css/daterangepicker.css';
import './assets/css/jquery.scrollbar.css';
import './assets/css/icons.autoproc.scss';
import './assets/css/sizing.css';
import './assets/css/animate.css';
import './assets/css/style.autoproc.scss';
import './assets/css/style.scss';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/automationstyle.scss';
import './assets/css/select2.css';

import 'jquery';

function setDir(lang: string) {
    const body = document.querySelector('body');
    const cls = lang == 'he-IL' ? 'rtl' : 'ltr';
    body?.classList.add(cls);
    body?.setAttribute('dir', cls);
}
(window as any).getExcelTemplate = mixin.methods.getExcelTemplate;

// Startup
(async (): Promise<void> => {
    const initResponse = await api.Init();
    if (initResponse.Data) {
        generalStore.dispatch('Init', initResponse.Data);

        const lang = initResponse.Data.Lang;
        await loadLanguageAsync(lang);
        setDir(lang);
    }

    const app = createApp(App);

    app.mixin({
        mixins: [mixin],
    });

    app.use(
        vfmPlugin({
            key: '$vfm',
            componentName: 'VueFinalModal',
            dynamicContainerName: 'ModalsContainer',
        })
    );

    app.config.globalProperties.$tbase = tbase;

    app.use(i18n);
    app.use(generalStore);
    app.use(router);
    app.use(VueClipboard);
    app.use(Toaster);
    app.use(useAccordion);
    app.use(HelpersPlugin);

    app.component('Select2', Select2);
    app.component('VUpload', FileUpload);
    app.component('ApModalBase', ApModalBase);
    app.component('BtnWithIcon', BtnWithIcon);
    app.component('Datepicker', Datepicker);
    app.component('KProgress', KProgress);

    app.directive('width', (el: any, binding: any) => {
        // this will be called for both `mounted` and `updated`
        if (typeof binding.value == 'number') {
            el.style.flex = `0 0 ${binding.value}px`;
        } else {
            el.style.flex = `0 0 ${binding.value}`;
        }
    });
    const onKeyPressed = (e: any) => {
        const v = e.target.value;
        if ((e.keyCode === 190 || e.keyCode === 110) && (v.includes('.') || !v)) {
            e.preventDefault();
            return;
        }
        if (
            [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };
    app.directive('numeric', (el, binding) => {
        el.removeEventListener('keydown', onKeyPressed);
        if (binding.value != false) {
            el.addEventListener('keydown', onKeyPressed);
        }
    });

    app.mount('#app');
})();
